import { render, staticRenderFns } from "./MainDeposit.vue?vue&type=template&id=39650032&scoped=true"
import script from "./MainDeposit.vue?vue&type=script&lang=ts"
export * from "./MainDeposit.vue?vue&type=script&lang=ts"
import style0 from "./MainDeposit.vue?vue&type=style&index=0&id=39650032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39650032",
  null
  
)

export default component.exports